// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import ReactEcharts from "echarts-for-react";
import { InputGroup } from "react-bootstrap";

import AgGridReactEx from "@app/components/AgGridReactEx";

import axios from "@app/lib/axios";

import FlyEngConstants from "@app/config/FlyEngConstants";

import flyengStyle from "../../components/style";

import { CardStatActivity } from "../../components/CardStatContent";

const defaultColDef = {
    flex: 1,
};

const totalBase = { total: 0, playCount: 0, playCountSum: 0 };
const Activity = forwardRef(({ statPeriod, libCategories }, ref) => {
    const [loadingData, setLoadingData] = useState(false);
    const [total, setTotal] = useState(totalBase);
    const [stat, setStat] = useState(false);
    const [statContent, setStatContent] = useState(false);
    const [statContentSum, setStatContentSum] = useState(false);
    const [tableData, setTableData] = useState(false);
    const [searchParam, setSearchParam] = useState({
        type: "title",
        value: "",
    });
    let colorContent = false;
    let colorContentSum = false;

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "플라잉홈_콘텐츠통계",
                sheets: [
                    {
                        name: "콘텐츠",
                        title: "콘텐츠 통계",
                        columnTitle: ["콘텐츠명", "카테고리", "메뉴", "순 실행 수", "누적 실행 수"],
                        data: stat ? stat.map((s) => [s.title, s.categoryName, s.pathName, s.cnt, s.cntSum]) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        setLoadingData(true);
        setStat(null);
        setTableData(null);
        axios({
            method: "POST",
            url: `/api/flyeng_stat_2022/home/activity`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
                page: 0,
                limit: -1,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data.list;
                    const total = { ...totalBase };

                    const statContent = libCategories.map((lc) => {
                        return { id: lc.id, name: lc.name, value: 0 };
                    });
                    const statContentSum = libCategories.map((lc) => {
                        return { id: lc.id, name: lc.name, value: 0 };
                    });
                    stat.forEach((s) => {
                        let execPath = null;
                        for (let i = 0; i < FlyEngConstants.HOME.EXECUTE_PATH.length; i++) {
                            execPath = FlyEngConstants.HOME.EXECUTE_PATH[i].sub.find((sub) => sub.path == s.path);
                            if (execPath) {
                                s.pathName = execPath.name;
                                break;
                            }
                        }
                        const lc = libCategories.find((lc) => lc.id == s.categoryId);
                        s.categoryName = lc ? lc.name : "-";
                        const level = FlyEngConstants.LEVEL.find((l) => l.age === s.age);
                        s.ageName = level ? `레벨${level.name}` : "-";
                        const sContent = statContent.find((sc) => s.categoryId == sc.id);
                        if (sContent) {
                            sContent.value += s.cnt;
                        }
                        const sContentSum = statContentSum.find((sc) => s.categoryId == sc.id);
                        if (sContentSum) {
                            sContentSum.value += s.cntSum;
                        }
                    });
                    total.total = stat.length;
                    total.playCount = statContent.reduce((ac, current) => ac + current.value, 0);
                    total.playCountSum = statContentSum.reduce((ac, current) => ac + current.value, 0);

                    setStat(stat);
                    setTotal(total);
                    setStatContent(statContent);
                    setStatContentSum(statContentSum);
                    applyData(searchParam, stat);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");

                setLoadingData(false);
            });
    }, [statPeriod]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, stat);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            let filters = null;
            if (searchParam.type == "categoryId") {
                filters = FlyEngConstants.HOME.CATEGORY.filter((c) => c.name.indexOf(searchParam.value) >= 0);
            } else if (searchParam.type == "age") {
                const age = searchParam.value.toLowerCase().charCodeAt(0) - 97;
                filters = [{ id: age }];
            }
            list.forEach((item) => {
                if (filters) {
                    filters.forEach((f) => {
                        if (item[searchParam.type] === f.id) {
                            if (tableDataNew.findIndex((d) => d.activityId == item.activityId) == -1) {
                                tableDataNew.push(item);
                            }
                        }
                    });
                } else {
                    if (item[searchParam.type] && item[searchParam.type].indexOf(searchParam.value) >= 0) {
                        if (tableDataNew.findIndex((d) => d.activityId == item.activityId) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                }
            });
        }
        return tableDataNew;
    };

    const onContentEvent = {
        finished: (e, charts) => {
            if (!colorContent) {
                colorContent = charts._model.option.color;
            } else {
                if (colorContent.length != charts._model.option.color.length) {
                    colorContent = charts._model.option.color;
                } else {
                    let changed = false;
                    for (let i = 0; i < colorContent.length; i++) {
                        if (colorContent[i] != charts._model.option.color[i]) {
                            changed = true;
                            break;
                        }
                    }
                    if (changed) {
                        colorContent = charts._model.option.color;
                    }
                }
            }
        },
    };
    const onContentSumEvent = {
        finished: (e, charts) => {
            if (!colorContentSum) {
                colorContentSum = charts._model.option.color;
            } else {
                if (colorContentSum.length != charts._model.option.color.length) {
                    colorContentSum = charts._model.option.color;
                } else {
                    let changed = false;
                    for (let i = 0; i < colorContentSum.length; i++) {
                        if (colorContentSum[i] != charts._model.option.color[i]) {
                            changed = true;
                            break;
                        }
                    }
                    if (changed) {
                        colorContentSum = charts._model.option.color;
                    }
                }
            }
        },
    };
    const optionContent = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, charts, test) => {
                const total = statContent ? statContent.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContent
                    ? statContent
                          .map(
                              (s, idx) =>
                              `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${
                                colorContent && colorContent.length > idx
                                      ? `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${colorContent[idx]};"></span>`
                                      : ""
                              }${s.name}: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return (
                    tip +
                    `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`
                );
            },
        },
        series: [
            {
                type: "pie",
                data: statContent,
                radius: ["0%", "90%"],
                animation: true,
                label: {
                    show: false,
                },
            },
        ],
        color: flyengStyle.seriesHomeColor.normal,
    };

    const optionContentSum = {
        tooltip: {
            trigger: "item",
            backgroundColor: "rgba(50,50,50,0.9)",
            formatter: (params, chart, test) => {
                const total = statContentSum ? statContentSum.reduce((ac, current) => ac + current.value, 0) : 0;
                const tip = statContentSum
                    ? statContentSum
                          .map(
                              (s, idx) =>
                                  `<div class='row' style='margin-left: 3px;margin-right: 3px;width: 200px'>${
                                      colorContentSum && colorContentSum.length > idx
                                          ? `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${colorContentSum[idx]};"></span>`
                                          : ""
                                  }${s.name}: ${s.value.toLocaleString()}, ${((s.value / total) * 100).toFixed(1)}%</div>`
                          )
                          .join("")
                    : "";
                return (
                    tip +
                    `<div style="height: 1px;border-bottom: 1px solid #aaa"></div><div class='row font-weight-bold m-1' style='width: 200px'>합계: ${total.toLocaleString()}</div>`
                );
            },
        },
        series: [
            {
                type: "pie",
                data: statContentSum,
                radius: ["0%", "90%"],
                animation: true,
                label: {
                    show: false,
                },
            },
        ],
        color: flyengStyle.seriesHomeColor.normal,
    };
    const listColumn = [
        {
            headerName: "No",
            headerClass: "bg-dark text-light",
            field: "id",
            sortable: false,
            width: 80,
            minWidth: 50,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "콘텐츠명",
            field: "title",
            cellClass: "text-left",
            minWidth: 135,
        },
        {
            headerName: "카테고리",
            field: "categoryName",
            minWidth: 70,
        },
        {
            headerName: "메뉴",
            field: "pathName",
            minWidth: 75,
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "실행 수",
            field: "cnt",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "누적 실행 수",
            field: "cntSum",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <div className="row">
                                <div className="col">
                                    <CardStatActivity id="1" title={`콘텐츠 순 실행 수`} total={total.playCount} titleBgClass="bg-tomonote" />
                                </div>
                                <div className="col">
                                    <CardStatActivity id="2" title={`콘텐츠 누적 실행 수`} total={total.playCountSum} titleBgClass="bg-tomonote" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 h-100">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h5 className="card-header-title">콘텐츠 사용 현황</h5>
                        </div>
                        <div className="card-body" style={{ height: "auto" }}>
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <span className="d-flex justify-content-end">- 순 사용량 -</span>
                                    <ReactEcharts theme="macarons" option={optionContent} style={{ height: `250px` }} onEvents={onContentEvent} />
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                    <span className="d-flex justify-content-end">- 누적 사용량 -</span>
                                    <ReactEcharts theme="macarons" option={optionContentSum} style={{ height: `250px` }} onEvents={onContentSumEvent} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData ? tableData.length.toLocaleString() : "0"} / {total ? total.total.toLocaleString() : "0"}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12">
                    <InputGroup className="input-group my-group">
                        <select
                            className="form-control input-group-append"
                            title="검색 항목 선택"
                            style={{ height: "auto", maxWidth: "120px" }}
                            value={searchParam.type}
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.type = e.target.value;
                                setSearchParam(param);
                            }}
                        >
                            <option value="title" defaultChecked>
                                콘텐츠
                            </option>
                            <option value="categoryId">카테고리</option>
                            <option value="age">레벨(A/B/C/D)</option>
                        </select>
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="콘텐츠명 | 카테고리 | 레벨(A/B/C/D)"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx defaultColDef={defaultColDef} columnDefs={listColumn} rowData={tableData} pagination={true} overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`} />
                </div>
            </div>
        </div>
    );
});

export default Activity;
